var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { autoUpdate, flip, offset as floatingOffset, useDismiss, useFloating, useFocus, useHover, useInteractions, } from '@floating-ui/react';
import { cloneElement, useState } from 'react';
import { useId, useMergeRefs } from '../hooks';
import { Text } from '../text';
import { tokens } from '../tokens';
import { tooltipStyle } from './styles';
// Mapping between Waffles and floating-ui placement
var placementMap = {
    bottom: 'bottom',
    bottomLeft: 'bottom-start',
    bottomRight: 'bottom-end',
    left: 'left',
    right: 'right',
    top: 'top',
    topLeft: 'top-start',
    topRight: 'top-end',
};
function Tooltip(_a) {
    var children = _a.children, content = _a.content, _b = _a.inverted, inverted = _b === void 0 ? false : _b, _c = _a.offset, offset = _c === void 0 ? tokens.spacing.small : _c, _d = _a.placement, placement = _d === void 0 ? 'bottom' : _d, restProps = __rest(_a, ["children", "content", "inverted", "offset", "placement"]);
    var _e = __read(useState(false), 2), isOpen = _e[0], setIsOpen = _e[1];
    var tooltipId = "tooltip-".concat(useId());
    var _f = useFloating({
        middleware: [floatingOffset(parseInt(offset, 10)), flip()],
        onOpenChange: setIsOpen,
        open: isOpen,
        placement: placementMap[placement],
        whileElementsMounted: autoUpdate,
    }), context = _f.context, refs = _f.refs, x = _f.x, y = _f.y;
    var _g = useInteractions([
        useHover(context, { delay: { close: 125, open: 750 } }),
        useFocus(context),
        useDismiss(context),
    ]), getFloatingProps = _g.getFloatingProps, getReferenceProps = _g.getReferenceProps;
    // @ts-expect-error: children.ref not recognized
    var triggerRef = useMergeRefs(refs.setReference, children.ref);
    var element = cloneElement(children, getReferenceProps(__assign(__assign({ key: children.key, ref: triggerRef }, children.props), (isOpen && { 'aria-describedby': tooltipId }))));
    return (_jsxs(_Fragment, { children: [element, isOpen && (_jsx(Text, __assign({}, getFloatingProps(__assign(__assign({}, restProps), { id: tooltipId, ref: refs.setFloating })), { as: "div", css: tooltipStyle({ inverted: inverted, x: x, y: y }), role: "tooltip" }, { children: content })))] }));
}
export default Tooltip;
